import { type AccountClient, withTurnstile } from "@nexxt/account-ui";
import { unwrap } from "@nexxt/api-client";
import { api, auth, signInAuth } from "./api";

// The sign-in and account screens on gateway-frontrow (ADR-207, ADR-216): one call per route, with the paths of
// gateway-atelier. The roads in go on the client of the sign-in pages, where a 401 is a refused credential; the rest
// on the client of the signed-in pages.

export const accountClient: AccountClient = {
  loginWithPassword: (json, turnstile) => unwrap(signInAuth.login.$post({ json }, withTurnstile(turnstile))),
  verifyTotp: (json) => unwrap(signInAuth.mfa.totp.$post({ json })),
  verifyRecoveryCode: (json) => unwrap(signInAuth.mfa["recovery-code"].$post({ json })),
  beginPasskeyLogin: () => unwrap(signInAuth.passkey.options.$post()),
  finishPasskeyLogin: (json) => unwrap(signInAuth.passkey.login.$post({ json })),
  requestPasswordReset: (json, turnstile) =>
    unwrap(signInAuth.password.forgot.$post({ json }, withTurnstile(turnstile))),
  resetPassword: (json, turnstile) => unwrap(signInAuth.password.reset.$post({ json }, withTurnstile(turnstile))),
  acceptInvitation: (json, turnstile) => unwrap(signInAuth.invitation.accept.$post({ json }, withTurnstile(turnstile))),
  confirmEmailChange: (json, turnstile) => unwrap(signInAuth.email.confirm.$post({ json }, withTurnstile(turnstile))),
  getMe: () => unwrap(auth.me.$get()),
  logout: () => unwrap(auth.logout.$post()),
  logoutEverywhere: () => unwrap(auth["logout-everywhere"].$post()),
  reauthenticate: (json) => unwrap(auth.reauthenticate.$post({ json })),
  listFactors: () => unwrap(auth.factors.$get()),
  enrollTotp: () => unwrap(auth.totp.enroll.$post()),
  confirmTotp: (json) => unwrap(auth.totp.confirm.$post({ json })),
  beginPasskeyRegistration: () => unwrap(auth.passkeys.options.$post()),
  registerPasskey: (json) => unwrap(auth.passkeys.$post({ json })),
  removeFactor: (input) =>
    input.factor === "totp"
      ? unwrap(auth.totp.$delete())
      : unwrap(auth.passkeys[":passkeyId"].$delete({ param: { passkeyId: input.passkeyId } })),
  regenerateRecoveryCodes: () => unwrap(auth["recovery-codes"].$post()),
  changePassword: (json) => unwrap(auth.password.change.$post({ json })),
  listSessions: () => unwrap(auth.sessions.$get()),
  closeSession: (param) => unwrap(auth.sessions[":sessionId"].$delete({ param })),
  requestEmailChange: (json) => unwrap(auth.email.change.$post({ json })),
  updateOwnProfile: (json) => unwrap(api.party["own-profile"].$patch({ json })),
  listMyNotificationPreferences: () => unwrap(api.notifications.preferences.$get()),
  setMyNotificationPreference: ({ templateCode, ...json }) =>
    unwrap(api.notifications.preferences[":templateCode"].$put({ param: { templateCode }, json })),
};
